// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","links":"Navbar_links__GNnVc"};